module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectLayout-1n"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer000"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/cover.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer001"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/ht.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "page-break-after": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer002"
    }
  }, [_c('p', {
    staticClass: "Normal ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Other Baby Blues")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("®")]), _c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v(" Books from Andrews McMeel Publishing")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Guess Who Didn’t Take a Nap?")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("I Thought Labor Ended When the Baby Was Born")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("We Are Experiencing Parental Difficulties . . . Please Stand By")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Night of the Living Dad")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("I Saw Elvis in My Ultrasound")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("One More and We’re Outnumbered!")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Check, Please . . .")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("threats, bribes & videotape")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("If I’m a Stay-at-Home Mom, Why Am I Always in the Car?")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Lift and Separate")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("I Shouldn’t Have to Scream More Than Once!")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Motherhood Is Not for Wimps")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Baby Blues")]), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("®")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v(": Unplugged")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Dad to the Bone")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Never a Dry Moment")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Two Plus One Is Enough")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Playdate: Category 5")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Our Server Is Down")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Something Chocolate This Way Comes")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Briefcase Full of Baby Blues")]), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("®")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Night Shift")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("The Day Phonics Kicked In")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("My Space")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("The Natural Disorder of Things")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("We Were Here First")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Ambushed! In the Family Room")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Cut!")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Eat, Cry, Poop")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Scribbles at an Exhibition")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Bedlam")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Wetter, Louder, Stickier")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Treasuries")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("The Super-Absorbent Biodegradable Family-Size Baby Blues")]), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("®")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Baby Blues")]), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("®")]), _c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v(": Ten Years and Still in Diapers")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Butt-Naked Baby Blues")]), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("®")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Wall-to-Wall Baby Blues")]), _c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("®")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Driving Under the Influence of Children")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Framed!")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("X-Treme Parenting")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("BBXX: Baby Blues: Decades 1 and 2 ")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Gift Book")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("It’s a Boy")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("It’s a Girl")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer003"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/title.jpg"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13ecead9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NoYelling_EPUB.vue
// module id = 57
// module chunks = 0